{
  "version": 1,
  "asset_id": "5caee627-6824-46fa-9e4d-5cbef5847fad",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/5caee627-6824-46fa-9e4d-5cbef5847fad/sleeve-ugi-reflux-pre-800-es.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/5caee627-6824-46fa-9e4d-5cbef5847fad/sleeve-ugi-reflux-pre-800-es.jpg",
  "original_filename": "sleeve-ugi-reflux-pre-800-es.jpg",
  "size": 71209,
  "content_type": "image/jpeg",
  "created_at": "2026-09-28T16:44:06Z"
}
